import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Container,
  Heading,
  Text,
  Grid,
  GridItem,
  Image,
} from "@chakra-ui/react";
import hero_image from "../img/hero_image.png";
import ButtonTheme from "./ButtonTheme";
import Providence_Medical_Pavillion from "../img/Providence_Medical_Pavillion.png";
import { RightIcon } from "./Icons";
import { propertyUrl } from "./Utils";
import {API_BASE_IMAGES} from "../OldApp";

const Banner = ({ location, properties }) => {
  const [relatedProperty, setRelatedProperty] = useState([]);

  const handleButtonClick = () => {
    window.location.href = "/search?address=" + location;
  };

  useEffect(() => {
    if (properties) {
      // Create an array of fetch promises
      const fetchPromises = properties.map((pro) =>
        fetch("/properties/" + pro.id + ".json", { mode: "cors" }).then(
          (response) => response.json()
        )
      );

      // When all fetch requests are complete
      Promise.all(fetchPromises)
        .then((data) => {
          console.log("relatedProperty..data", data);
          setRelatedProperty(data);

          // setRelatedProperty(prevProperties => [...prevProperties, ...data]);
          console.log("relatedProperty..", relatedProperty);
        })
        .catch((error) => console.error(error));
    }
  }, [properties]);

  return (
    <Flex
      bgImage={hero_image}
      bgSize={"cover"}
      h={{ xl: "800px", md: "600px", sm: "700px",base: "800px" }}
      flexDir={"column"}
      justifyContent={"space-between"}
      pb={6}
    >
      <Container
        maxW={{ md: "85%", base: "95%" }}
        pos={"relative"}
        pt={{ xl: 36, base: 28 }}
      >
        <Box w={{ xl: "70%", lg: "80%", md: "90%", base: "100%" }}>
          <Heading
            fontSize={{ xl: "7xl", lg: "6xl", base: "5xl" }}
            color={"BrightTurquoise"}
          >
            Focus on your patients, we'll handle the real estate
          </Heading>
          <Text
            color={"white"}
            my={{ xl: 5, sm: 3, base: 6 }}
            fontSize={{ md: "md", base: "sm" }}
            fontWeight={"400"}
          >
            Trust Welltower to partner with you on the perfect medical space to
            address the complex needs of your practice so you can focus on
            delivering the highest quality of care to your patients.
          </Text>
          <ButtonTheme
            btnText={"Find your space"}
            location={location}
            handleButtonClick={handleButtonClick}
            chakraProps={{
              id: "btn_find_your_space"
            }}
          />
        </Box>
      </Container>
      {location && (
        <Container
          maxW={"95%"}
          pos={"relative"}
          className="closest-locations-results"
        >
          <Box>
            <Text fontWeight={"400"} color={"white"} mb={5}>
              Showing closest results for{" "}
              <Text as={"span"} fontWeight={"600"}>
                {" "}
                {location}
              </Text>
            </Text>
            <Grid
              gridTemplateColumns={{
                lg: "repeat(3, 1fr)",
                md: "repeat(1, 1fr)",
              }}
              gap={{ xl: 10, lg: 8 }}
            >
              {relatedProperty.map((property, index) => (
                <GridItem
                  key={index}
                  transition={"all ease .5s"}
                  cursor={"pointer"}
                  className={"banner-related-property"}
                  id={`banner_related_property${index}`}
                >
                  <Flex alignItems={"center"}>
                    <Box display={{ xl: "inline-block", base: "none" }}>
                      <a href={propertyUrl(property)}>
                        <Image
                          src={API_BASE_IMAGES + property?.photos?.[0]?.path_300}
                          w={"83px"}
                          h={"83px"}
                          pos={"relative"}
                          zIndex={9}
                          borderRadius={"full"}
                        />
                      </a>
                    </Box>
                    <Flex
                      className="border-animate"
                      ms={{ xl: -10, base: 0 }}
                      py={2}
                      ps={{ xl: 14, lg: 6, base: 0 }}
                      pe={{ xl: 6, base: 0 }}
                      border={{ xl: "1px solid white", base: "0" }}
                      borderRadius={"100px"}
                      borderLeft={0}
                      flexGrow={1}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Box>
                        <Text color={"white"} noOfLines={1}>
                          <a
                            href={
                              propertyUrl(property)
                            }
                          >
                            {property?.name || ""}
                          </a>
                        </Text>
                        <Text
                          color={"white"}
                          fontWeight={"400"}
                          fontStyle={"italic"}
                          display={{ xl: "inline-block", base: "none" }}
                        >
                          <a
                            href={
                              propertyUrl(property)
                            }
                          >
                            {property?.street_address || ""}
                          </a>
                        </Text>
                      </Box>
                      <RightIcon
                        sx={{
                          line: {
                            stroke: "white",
                          },
                        }}
                      />
                      {/* <Box
                        className="right-arrow"
                        padding={"10px"}
                        boxShadow={"1px -1px 0 1px white inset"}
                        border={"solid transparent"}
                        transition={"0.2s"}
                        transform={"rotate(225deg)"}
                      /> */}
                    </Flex>
                  </Flex>
                </GridItem>
              ))}
            </Grid>
          </Box>
        </Container>
      )}
    </Flex>
  );
};

export default Banner;
